import { render, staticRenderFns } from "./debug-mode-indicator.vue?vue&type=template&id=00df2828&scoped=true"
import script from "./debug-mode-indicator.vue?vue&type=script&lang=js"
export * from "./debug-mode-indicator.vue?vue&type=script&lang=js"
import style0 from "./debug-mode-indicator.vue?vue&type=style&index=0&id=00df2828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df2828",
  null
  
)

export default component.exports